export default __webpack_public_path__ + "static/media/samatur_viajar_com_desconto.c2c3fd74.WEBP";